<div class="mat-elevation-z5">
  <div class="uf-dialog-header">
    <mat-toolbar color="primary">
      <h1 class="mat-title">{{title}}</h1>
      <div class="uf-filler"></div>
    </mat-toolbar>
  </div>
  <div mat-dialog-content class="no-padding">
    <form class="search" [formGroup]="filterForm" (ngSubmit)="loadData()">
      <mat-form-field>
        <mat-label>Zoeken</mat-label>
        <input #searchInput matInput type="text" formControlName="name">
        <button matSuffix mat-icon-button type="submit" aria-label="Zoeken">
          <mat-icon svgIcon="magnify"></mat-icon>
        </button>
      </mat-form-field>
    </form>
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Naam</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.firstName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="familyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Achternaam</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.familyName}}
          @if (item.infix) {
            <span>, {{item.infix}}</span>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="companyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Bedrijfsnaam</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.companyName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="address">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Adres</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.address}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Plaats</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.city}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="source">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          @if (item.source === 'R') {
            <span>
              <mat-icon svgIcon="account-check-outline" color="primary" matTooltip="Bestaande relatie"></mat-icon>
            </span>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="select(row)"></mat-row>
    </mat-table>
    @if (dataSource.data.length === 0) {
      <div class="not-found">
        - Er zijn geen resultaten gevonden -
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <mat-paginator [length]="dataSource.records" [pageSizeOptions]=pageSizeOptions></mat-paginator>
    </div>
    <div>
      <button mat-button (click)="close()" cdkFocusInitial>Annuleer</button>
    </div>
  </div>
</div>
